import React from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import { getIconByType } from '../../../mapComponents/Popups/PopupUtil';
import { compose } from 'recompose';

const styles = () => ({
  iconsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  }
});

const SpecialNeedsRenderer = ({ iconsList, theme, classes }) => {
  if (!iconsList.length) return <div>-</div>;
  return (
    <div className={classes.iconsContainer}>
      {iconsList.map((icon) => {
        const renderedIcon = getIconByType({
          iconData: icon,
          backgroundColor: theme.dispatchPanelLabelValueColor
        });
        return renderedIcon;
      })}
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(SpecialNeedsRenderer);
